import moment from "moment";
import { useState } from "react";
import { useMount, useUpdateEffect } from "react-use";
import GenderInput from "./GenderInput";
import BirthDateInput from "./BirthDateInput";
import SchoolInput from "./SchoolInput";

const FindOutInfo = ({
  method,
  sendResult,
  confirmResult,
  onSend,
  onConfirm,
}) => {
  const [value, setValue] = useState("");
  const [code, setCode] = useState("");
  const [msg, setMessage] = useState({ info: "", sent: "", verified: "" });
  const [isAvailable, setAvailable] = useState(false);
  const [isSent, setSent] = useState(false);
  const [isVerified, setVerified] = useState(false);
  const [time, setTime] = useState(0);
  const [data, setData] = useState({
    birth_date: "",
    school: null,
    gender: null,
  });

  useUpdateEffect(() => {
    if (sendResult === null) return;
    const { result, t, m } = sendResult;
    if (result && t && m) {
      setTime(t);
    }
    setMessage({ ...msg, sent: m });
    setSent(result);
  }, [sendResult]);

  useUpdateEffect(() => {
    if (confirmResult === null) return;
    const { result, m } = confirmResult;
    if (result) {
      setTime(0);
    }
    setMessage({ ...msg, sent: m });
    setSent(result);
  }, [confirmResult]);

  // 전화번호 유효성 검사 함수
  const validateTel = (tel) => {
    return new RegExp("^(010|070)[0-9]{8}$").test(tel);
  };
  // 이메일 유효성 검사 함수
  const validateEmail = (email) => {
    return new RegExp("^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,}$").test(
      email
    );
  };

  const handleChange = (e) => {
    const { value: val, id: target } = e.target;
    if (method !== "info") {
      let v = val.replace(/\s/g, "");
      if (target === "code") {
        v = v.replace(/[^\d]/g, "");
        setCode(v);
        setMessage({ info: "", sent: "", verified: "" });
      } else {
        setAvailable(false);
        setCode("");
        setSent(false);
        if (method === "tel") {
          v = v.replace(/[^0-9]/g, "");
          if (validateTel(v)) {
            setAvailable(true);
            setMessage({ ...msg, sent: "", info: "" });
          } else {
            setMessage({
              ...msg,
              sent: "",
              info: "유효한 번호 형식으로 입력하세요.",
            });
          }
        }
        if (method === "email") {
          if (validateEmail(v)) {
            setAvailable(true);
            setMessage({ ...msg, sent: "", info: "" });
          } else {
            setMessage({
              ...msg,
              sent: "",
              info: "유효한 메일 형식으로 입력하세요.",
            });
          }
        }
        setValue(v);
      }
    } else {
      setMessage({ info: "", sent: "", verified: "" });
      if (target === "birth_date" || target === "school") {
        setData({ ...data, [target]: val });
      } else {
        const [k, v] = target.split("_");
        setData({ ...data, [k]: v.toUpperCase() });
      }
    }
  };

  const handleSendVerify = () => {
    // 입력한 정보(이름, 휴대전화번호)로 회원존재 여부 확인하고 일치할 경우 인증번호 발송
    onSend(method === "info" ? data : { [method]: value });
  };

  const handleConfirmVerify = () => {
    // 인증번호 일치하는지 확인후 아이디 전체 반환
    onConfirm({ code });
  };

  const handleConfirmInfo = () => {
    // 입력정보(이름, 성별, 생년월일, 학교) 일치하는지 확인후 아이디 일부 반환
    onConfirm({ ...data, school: data.school && data.school.code });
  };

  useUpdateEffect(() => {
    let timer;
    if (time) {
      timer = setInterval(() => {
        if (time < 1000) {
          setTime(0);
          clearInterval(timer);
        } else {
          setTime(time - 1000);
        }
      }, 1000);
    } else {
      if (!isVerified) {
        setSent(false);
      }
    }

    return () => {
      timer && clearInterval(timer);
    };
  }, [time]);

  useMount(() => {
    setValue("");
    setCode("");
    setMessage({ info: "", sent: "", verified: "" });
    setAvailable(false);
    setSent(false);
    setVerified(false);
    setTime(0);
  });

  return (
    <>
      {method !== "info" && (
        <div className="form-control">
          <input
            type={method}
            placeholder={method === "tel" ? "휴대전화번호" : "이메일주소"}
            className={`input input-bordered`}
            onChange={handleChange}
            value={value}
            readOnly={isVerified}
          />
          <div className="flex flex-col mt-1">
            {!isAvailable && (
              <span className="text-sm text-red-500 text-left">{msg.info}</span>
            )}
            {value && !isSent && isAvailable && (
              <>
                {msg.sent && (
                  <span className="text-sm text-left text-red-500">
                    {msg.sent}
                  </span>
                )}
                <button
                  className="btn btn-accent mt-2"
                  disabled={!isAvailable}
                  onClick={handleSendVerify}
                >
                  인증번호 보내기
                </button>
              </>
            )}
            {value && isAvailable && isSent && !isVerified && (
              <>
                <div className="inline-flex items-center gap-2">
                  <input
                    id="code"
                    type="text"
                    placeholder="인증번호"
                    className={`input input-bordered flex-auto${
                      code.length === 5 ? " border-primary" : ""
                    }`}
                    onChange={handleChange}
                    value={code}
                  />
                  <span className="text-primary">
                    {new moment(time).format("mm:ss")}
                  </span>
                </div>
                <button
                  className="btn btn-accent mt-2"
                  disabled={!code || code.length !== 5}
                  onClick={handleConfirmVerify}
                >
                  확인
                </button>
              </>
            )}
            {isVerified && (
              <span className="text-sm text-left text-green-500">
                {msg.verified}
              </span>
            )}
            {isSent && !isVerified && (
              <span className="text-sm text-left text-red-500">
                {msg.verified}
              </span>
            )}
          </div>
        </div>
      )}
      {method === "info" && (
        <div className="form-control gap-2">
          <GenderInput
            {...{
              gender: data.gender,
              onChange: handleChange,
              className: "h-12 text-sm",
            }}
          />
          <BirthDateInput
            {...{ birth_date: data.birth_date, onChange: handleChange }}
          />
          <SchoolInput
            {...{
              school: data.school,
              onChange: handleChange,
            }}
          />
          {!!msg.sent && (
            <span className="text-sm text-left text-red-500">{msg.sent}</span>
          )}
          <button
            className="btn btn-primary mt-2"
            disabled={!!msg.sent}
            onClick={handleConfirmInfo}
          >
            정보 확인
          </button>
        </div>
      )}
    </>
  );
};

export default FindOutInfo;
